import { render, staticRenderFns } from "./cart-dropdown.vue?vue&type=template&id=4888f60d&scoped=true&lang=pug&"
import script from "./cart-dropdown.vue?vue&type=script&lang=js&"
export * from "./cart-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./cart-dropdown.vue?vue&type=style&index=0&id=4888f60d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888f60d",
  null
  
)

/* custom blocks */
import block0 from "./cart-dropdown.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "cart-dropdown.vue"
export default component.exports